import { StrictMode, useEffect, lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import 'typeface-roboto';
import 'registry'; //register functions to be used across application
//import 'components/tableCellComponents'; //register table cell components
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
//import ErrorBoundary from "errorBoundary/errorBoundary";
//import 'pages_los/metaData/utils';
import Loader from 'assets/Loader';
const CreditScore = lazy(() => import('app/creditScore'));
// const Middleware = lazy(() => import('app/middleware'));

// need to commit this if error comes
// require('dotenv').config();

const Redirect = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('credit-score');
  }, [navigate]);
  return null;
};

const App = () => (
  <StrictMode>
    <DndProvider backend={HTML5Backend}>
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          {/* <ErrorBoundary> */}
          <Routes>
            <Route path="credit-score/*" element={<CreditScore />} />
            {/* <Route path="middleware/*" element={<Middleware />} /> */}
            <Route path="*" element={<Redirect />} />
          </Routes>
          {/* </ErrorBoundary> */}
        </Suspense>
      </BrowserRouter>
    </DndProvider>
  </StrictMode>
);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
